<template>
    <div>
        <div class="main">
            <div v-if="$store.state.settings.mode ==='mobile'" class="head">
                <img src="../../../assets/images/index/zjt.png" alt="" @click="fallback">
                <div>联系方式</div>
            </div>

            <div v-if="$store.state.settings.mode ==='pc'" class="nav">
                <div class="container">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item v-for="(item, index) in policyList" :key="index" :to="{name: item.routerLink,params:{cId:item.cId}}">{{ item.name }}</el-breadcrumb-item>
                    </el-breadcrumb>

                    <h4>{{ title }}</h4>
                    <span class="text">{{ eTitle }}</span>
                </div>
            </div>
            <div v-else class="contact-text">
                <div>联系方式</div>
                <div>contact information</div>
            </div>
            <div :class="$store.state.settings.mode ==='pc'? 'map' : 'mobileMap'">
                <BdMap :data="data" />
            </div>
            <div v-if="$store.state.settings.mode ==='pc'" class="map-text">
                <div class="top-text">
                    <span>电    话： {{ data.mobile }}</span>
                    <span>地    址： {{ data.area }}</span>
                </div>
                <div class="bottom-text">
                    <span>传    真： {{ data.fax }}</span>
                    <span>邮    箱： {{ data.email }}</span>
                    <span>微信公众号： {{ data.wechat_name }}</span>
                </div>
            </div>
            <div v-else class="mobileMain">
                <div class="text">电    话： {{ data.mobile }}</div>
                <div class="text">地    址： {{ data.area }}</div>
                <div class="text">传    真： {{ data.fax }}</div>
                <div class="text">邮    箱： {{ data.email }}</div>
                <div class="text">微信公众号： {{ data.wechat_name }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: {
                area: '',
                email: '',
                fax: '',
                mobile: '',
                wechat_name: ''
            },
            policyList: [
                {
                    name: '首页',
                    routerLink: 'index',
                    cId: ''
                },
                {
                    name: 'CMCA介绍',
                    routerLink: 'Policies',
                    cId: '2'
                },
                {
                    name: '联系方式',
                    routerLink: ''
                }
            ],
            title: '联系方式',
            eTitle: 'contact information',
            bannerList: []
        }
    },

    mounted() {
        this.$api.get('webInfo/otherInfo').then(res => {
            this.data = res.data
        })
        this.bannerRequest()
    },
    methods: {
        bannerRequest() {
            this.$api.get('banner/qList').then(res => {
                this.bannerList = res.data.list
            })
        },
        fallback() {
            this.$router.go(-1)
        }
    }

}

</script>

<style lang="scss" scoped>
.main {
    #allmap {
        height: 300px;
        width: 500px;
    }
    .case-container {
        width: 1920px;
        margin: 0 auto;
        position: relative;
        top: 0;
        font-size: 0;
        .swiper-container {
            height: 100%;
            font-size: 0;
            .swiper-slide img {
                width: 100%;
                height: 100%;
                display: block;
                font-size: 0;
            }
            img {
                vertical-align: buttom;
                vertical-align: middle;
                vertical-align: top;
            }
            .swiper-slide { height: 10px; }
            .swiper-slide-active { height: auto; }
        }
        .new-list {
            position: absolute;
            top: 0;
            right: 380px;
            z-index: 99;
        }
        #map {
            width: 500px;
            height: 500px;
        }
        .bannar-box {
            width: 1920px;
            height: 360px;
        }
    }
    .map {
        width: 1200px;
        height: 240px;
        margin: 0 auto;
        margin-top: 76px;
        padding-bottom: 40px;
        position: relative;
        .bm-view {
            width: 100%;
            height: 100%;
        }
    }
    .mobileMap {
        margin: 15px 0;
        #bmap {
            width: calc(100% - 30px) !important;
            height: 160px !important;
        }
    }
    .map-text {
        width: 1200px;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 42px;
        .top-text {
            display: flex;
            justify-content: space-around;
            width: 60%;
            span {
                &:first-child {
                    flex-shrink: 1;
                    display: block;
                }
                &:last-child {
                    flex-shrink: 6;
                    display: block;
                }
            }
        }
        .bottom-text {
            display: flex;
            justify-content: space-around;
            margin-top: 10px;
            padding-bottom: 180px;
            width: 70%;
            span {
                &:nth-child(1) {
                    flex-shrink: 1;
                    display: block;
                }
                &:nth-child(2) {
                    flex-shrink: 6;
                    display: block;
                }
                &:nth-child(3) {
                    flex-shrink: 6;
                    display: block;
                }
            }
        }
    }
    .nav {
        width: 100%;
        .container {
            width: 1200px;
            margin: 0 auto;
            padding-top: 30px;
            span {
                font-size: 16px;
                font-weight: 400 !important;
                color: #999 !important;
                line-height: 50px;
                cursor: pointer;
                display: block;
                -moz-user-select: none; /* 火狐 */
                -webkit-user-select: none; /* webkit浏览器 */
                -ms-user-select: none; /* IE10 */
                -khtml-user-select: none; /* 早期浏览器 */
            }
            ul {
                list-style: none;
                width: 280px;
                display: flex;
                justify-content: space-between;
                padding-left: 0;
                li {
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    line-height: 30px;
                    cursor: pointer;
                    -moz-user-select: none; /* 火狐 */
                    -webkit-user-select: none; /* webkit浏览器 */
                    -ms-user-select: none; /* IE10 */
                    -khtml-user-select: none; /* 早期浏览器 */
                    padding-left: 4px;
                    &:last-child {
                        font-size: 16px;
                        font-weight: 400;
                        color: #333;
                        line-height: 30px;
                    }
                }
            }
            .zcfg {
                width: 200px;
            }
            .contact-name {
                font-size: 30px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 30px;
                width: 100%;
                display: block;
                text-align: center;
                margin-top: 50px;
                margin-bottom: 10px;
            }
            .contact-name-e {
                font-size: 18px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 30px;
                width: 100%;
                display: block;
                text-align: center;
            }
            h4 {
                font-size: 30px;
                font-weight: 400;
                color: rgba(71, 71, 71, 1);
                line-height: 30px;
                margin-bottom: 12px;
                text-align: center;
            }
            .text {
                font-size: 18px;
                display: block;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 20px;
                text-align: center;
            }
        }
    }
    .contact-text {
        padding: 20px 15px 24px;
        border-bottom: 1px solid #eee;
        div:nth-child(1) {
            font-size: 20px;
            font-weight: 600;
            text-align: center;
            color: #000;
            margin-bottom: 12px;
        }
        div:nth-child(2) {
            font-size: 16px;
            font-weight: 400;
            text-align: center;
            color: #999;
        }
    }
    ::v-deep .el-breadcrumb__inner {
        font-size: 16px;
        font-weight: 400 !important;
        color: #999 !important;
        line-height: 30px;
    }
}
.mobileMain {
    .text {
        padding: 0 15px 10px;
    }
}
.head {
    height: 60px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
    img {
        width: 10px;
        height: 16px;
    }
    div {
        flex: 1;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        color: #000;
    }
}
</style>
